import { render, staticRenderFns } from "./cabinet-commercial-notice-card-cancel-button.vue?vue&type=template&id=f6fef3bc&"
import script from "./cabinet-commercial-notice-card-cancel-button.vue?vue&type=script&lang=js&"
export * from "./cabinet-commercial-notice-card-cancel-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6fef3bc')) {
      api.createRecord('f6fef3bc', component.options)
    } else {
      api.reload('f6fef3bc', component.options)
    }
    module.hot.accept("./cabinet-commercial-notice-card-cancel-button.vue?vue&type=template&id=f6fef3bc&", function () {
      api.rerender('f6fef3bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/commercial/cards/partials/cabinet-commercial-notice-card-cancel-button.vue"
export default component.exports